import { render, staticRenderFns } from "./BuyerAccountBudget.vue?vue&type=template&id=3309f684&scoped=true"
import script from "./BuyerAccountBudget.vue?vue&type=script&lang=js"
export * from "./BuyerAccountBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309f684",
  null
  
)

export default component.exports